import { render, staticRenderFns } from "./verify-email-step.vue?vue&type=template&id=08f104dd"
import script from "./verify-email-step.vue?vue&type=script&lang=js"
export * from "./verify-email-step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports